import { SearchBar } from "components/SearchBar";
import { IFilterOptions } from "contexts/map/types";
import { useGlobalMapActions } from "contexts/map";
import * as S from "./styles";

export type FilterMenuOption = {
  id: string;
  label: string;
  value: number;
  isActive: boolean;
};

type FilterButtonProps = {
  filter: FilterMenuOption;
  onFilterClick: (filter: FilterMenuOption) => void;
};

function FilterButton({ filter, onFilterClick }: FilterButtonProps) {
  return (
    <S.FilterButton
      isActive={filter.isActive}
      onClick={() => onFilterClick(filter)}
    >
      {filter.label}
      <S.FilterButtonValue>{filter.value}</S.FilterButtonValue>
    </S.FilterButton>
  );
}

type Props = {
  filters: IFilterOptions;
  onFilterChange: (filter: FilterMenuOption) => void;
};

export function FilterMenu({ filters, onFilterChange }: Props) {
  const { handleSearchTextChange } = useGlobalMapActions();

  const handleFilterClick = (filter: FilterMenuOption) => {
    filter.isActive = !filter.isActive;
    onFilterChange(filter);
  };

  return (
    <S.Wrapper>
      <SearchBar
        type="text"
        name="filter"
        id="filter"
        placeholder="Procure por protocolo da ocorrência ou nome do agente"
        buttonText=""
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          handleSearchTextChange(event.target.value);
        }}
        required={false}
        disabled
        onClick={() => {}}
      />

      <S.FilterContainer>
        <label>Selecionar o que mostrar no mapa</label>

        <div>
          {Object.keys(filters).map((key) => (
            <FilterButton
              filter={filters[key as keyof IFilterOptions]}
              onFilterClick={handleFilterClick}
            />
          ))}
        </div>
      </S.FilterContainer>
    </S.Wrapper>
  );
}
